import React from 'react';

export class GotopButton extends React.Component {

  goTopButton = () => {
    var smoothScroll = require('smoothscroll');
    smoothScroll(0)
  }

  render() {
    return (
      <svg
        id="gotopButton"
        width="80px"
        height="80px"
        viewBox="0 0 80 80"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        onClick={this.goTopButton}
      >
        <g
          id="gotop"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <circle fill="#6DCD78" cx="40" cy="40" r="40"></circle>
          <polygon fill="#FFFFFF" points="40.2106526 25.1458256 28.2898115 37.0666667 26.9333333 35.7101885 39.9981604 22.6453614 40.2106526 22.8578536 40.4231449 22.6453614 53.4879719 35.7101885 52.1314937 37.0666667"></polygon>
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GotopButton.js